module.exports = __webpack_public_path__ + "img/ics_o_maps.2e1704df.svg";